import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'ChatTags',
  initialState: { byId: {}, allIds: [], loading: false },
  reducers: {
    loadStarted(state) { state.loading = true; },
    loaded(state, { payload }) {
      state.byId = {};
      state.allIds = [];
      for (const t of payload) { state.byId[t._id] = t; state.allIds.push(t._id); }
      state.loading = false;
    },
    upserted(state, { payload }) {
      state.byId[payload._id] = payload;
      if (!state.allIds.includes(payload._id)) state.allIds.push(payload._id);
    },
    removed(state, { payload }) {
      delete state.byId[payload];
      state.allIds = state.allIds.filter((id) => id !== payload);
    },
  },
});
export const { loadStarted, loaded, upserted, removed } = slice.actions;
export default slice.reducer;
